import { formatBusinessName } from "./nameFormatters";
import { Colors } from "../styles/colors";

export const getNodeSize = (node, entity) => {
    switch (node.type) {
        case 'COMPANY':
            return node.id === entity.business_entity_id ? 28 : 20;
        default: return 18;
    }
};

export const getNodeColor = (node, entity) => {
    switch (node.type) {
        case 'COMPANY':
            return Colors.PRIMARY_DARK;
        case 'PERSON':
            return Colors.PERSON_NODE_BLUE;
        case 'ADDRESS':
            return Colors.ADDRESS_NODE_BLUE;
        default:
            return '#999';
    }
};

export const getNodeStrokeColor = (node, entity) => {
    switch (node.type) {
        case 'COMPANY':
            return node.id === entity.business_entity_id ? Colors.PRIMARY_DARK : Colors.COMPANY_NODE_STROKE;
        case 'PERSON':
            return Colors.PERSON_NODE_STROKE;
        case 'ADDRESS':
            return Colors.ADDRESS_NODE_STROKE;
        default:
            return '#999';
    }
};

export const getNodeInnerIconPosition = (nodeType) => {
    switch (nodeType) {
        case 'COMPANY':
            return 7
        default: return 6
    }
}

export const getNodeFontSize = (node, entity) => {
    switch (node.type) {
        case 'COMPANY': return node.id === entity.business_entity_id ? "28px" : "20px"
        default: return "18px"
    }
}

export const getNodeLabel = (node) => {
    const label = formatBusinessName(node.label);
    return label.length > 20 ? label.substring(0, 17) + '...' : label;
}

export const getNodeIcon = (nodeType) => {
    switch (nodeType) {
        case 'COMPANY':
            return 'business';
        case 'PERSON':
            return 'person';
        case 'ADDRESS':
            return 'location_on';
        default:
            return '';
    }
};

export const isExecutiveRole = (label) => {
    if (!label || typeof label !== 'string') {
        return false;
    }

    const lowerLabel = label.toLowerCase();

    return lowerLabel.includes('officer') ||
        lowerLabel.includes('owner') ||
        lowerLabel.includes('ceo') ||
        lowerLabel.includes('executive') ||
        lowerLabel.includes('agent') ||
        lowerLabel.includes('organizer') ||
        lowerLabel.includes('manager') ||
        lowerLabel.includes('director') ||
        lowerLabel.includes('secretary') ||
        lowerLabel.includes('cfo') ||
        lowerLabel.includes('cto') ||
        lowerLabel.includes('coo')
};

